export default __webpack_public_path__ + "static/media/3.62d68b6c.jpg";